module.exports = function (app, mod) {
  return "<div class=\"invites arcade-invites\"></div>";
};